// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wROX","rootNoMargin":"styles_rootNoMargin__OfDzP"};